var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.mainDebug == true
    ? _c(
        "div",
        [
          _c(
            "base-collapse",
            {
              on: { change: _vm.handleChange },
              model: {
                value: _vm.activeNames,
                callback: function ($$v) {
                  _vm.activeNames = $$v
                },
                expression: "activeNames",
              },
            },
            [
              _c(
                "base-collapse-item",
                { attrs: { title: "Master Debug", name: "0" } },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                      },
                      [
                        _c(
                          "base-collapse-item",
                          {
                            attrs: {
                              title: "Product classification search criteria",
                              name: "1",
                            },
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-3 class_header" },
                                      [_vm._v("Country :")]
                                    ),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm._v(
                                        _vm._s(_vm.prodClassCriteria.country)
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-3 class_header" },
                                      [_vm._v(" Medical Device Type : ")]
                                    ),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.prodClassCriteria
                                              .medical_device_type
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-3 class_header" },
                                      [_vm._v(" Kit Component Pass Counter : ")]
                                    ),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.ivdrCurrCtr) +
                                          "--" +
                                          _vm._s(
                                            _vm.prodClassCriteria.componentName
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-3 class_header" },
                                      [_vm._v(" Medical Product Name : ")]
                                    ),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.prodClassCriteria.device_name
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-3 class_header" },
                                      [_vm._v(" Classification Finalized : ")]
                                    ),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.prodClassCriteria
                                              .classificationFinalized
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-3 class_header" },
                                      [_vm._v("Level Array:")]
                                    ),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm._v(_vm._s(_vm.sortedLevelArray)),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-3 class_header" },
                                      [_vm._v("Level Array (Kit):")]
                                    ),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm._v(_vm._s(_vm.sortedLevelArrayKit)),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "base-collapse-item",
                          {
                            attrs: {
                              title: "Classification Questions and Responses",
                              name: "2",
                            },
                          },
                          [
                            _c("div", [
                              _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    { staticClass: "row class_header" },
                                    [
                                      _c("div", { staticClass: "col-xs-1" }, [
                                        _vm._v("Step"),
                                      ]),
                                      _c("div", { staticClass: "col-md-4" }, [
                                        _vm._v("Question"),
                                      ]),
                                      _c("div", { staticClass: "col-md-3" }, [
                                        _vm._v("Response"),
                                      ]),
                                      _c("div", { staticClass: "col-xs-1" }, [
                                        _vm._v("Level"),
                                      ]),
                                      _c("div", { staticClass: "col-md-1" }, [
                                        _vm._v("Interim Class"),
                                      ]),
                                      _c("div", { staticClass: "col-md-1" }, [
                                        _vm._v("Rule Ref"),
                                      ]),
                                    ]
                                  ),
                                  _vm._l(
                                    _vm.workflowDataArray,
                                    function (data, index) {
                                      return _c(
                                        "div",
                                        { key: index, staticClass: "row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-xs-1" },
                                            [_vm._v(_vm._s(index + 1))]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4" },
                                            [_vm._v(_vm._s(data.question))]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-3" },
                                            [_vm._v(_vm._s(data.answer))]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col-xs-1" },
                                            [_vm._v(_vm._s(data.level))]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-1" },
                                            [_vm._v(_vm._s(data.interimClass))]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-1" },
                                            [_vm._v(_vm._s(data.ruleRef))]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "base-collapse-item",
                          {
                            attrs: { title: "Classification Misc", name: "3" },
                          },
                          [
                            _c("div", [
                              _c(
                                "div",
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-md-3" }, [
                                      _vm._v("Classification Code:"),
                                    ]),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.prodClassCriteria
                                              .compositeArrayWrapper.classCode
                                          ) +
                                          "-" +
                                          _vm._s(
                                            _vm.prodClassCriteria
                                              .compositeArrayWrapper
                                              .classFoundFlag
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-md-3" }, [
                                      _vm._v("Classification Data:"),
                                    ]),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm._v(_vm._s(_vm.classData)),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-md-3" }, [
                                      _vm._v("Choices:"),
                                    ]),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.prodClassCriteria
                                              .searchCriteriaArray
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-md-3" }, [
                                      _vm._v(
                                        "Workflow ResponseCache Component"
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "col-md-2" }, [
                                    _vm._v("Component Name"),
                                  ]),
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _vm._v("Class Code"),
                                  ]),
                                  _c("div", { staticClass: "col-md-7" }, [
                                    _vm._v("Data Cache"),
                                  ]),
                                  _vm._l(
                                    _vm.prodClassCriteria.workflowResponseMap,
                                    function (data, key, index) {
                                      return _c("div", { key: index }, [
                                        _c("div", { staticClass: "col-md-2" }, [
                                          _vm._v(_vm._s(data[1].name)),
                                        ]),
                                        _c("div", { staticClass: "col-md-3" }, [
                                          _vm._v(_vm._s(data[1].classCode)),
                                        ]),
                                        _c("div", { staticClass: "col-md-7" }, [
                                          _vm._v(_vm._s(data[1].cache.length)),
                                        ]),
                                      ])
                                    }
                                  ),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-md-3" }, [
                                      _vm._v("Level Array Component"),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "col-md-2" }, [
                                    _vm._v("Component Name"),
                                  ]),
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _vm._v("Class Code"),
                                  ]),
                                  _c("div", { staticClass: "col-md-7" }, [
                                    _vm._v("Data Cache"),
                                  ]),
                                  _vm._l(
                                    _vm.prodClassCriteria.mapLevelArray,
                                    function (lvlArr, key, index) {
                                      return _c("div", { key: index }, [
                                        _c("div", { staticClass: "col-md-2" }, [
                                          _vm._v(_vm._s(key)),
                                        ]),
                                        _c("div", { staticClass: "col-md-3" }, [
                                          _vm._v(_vm._s(index)),
                                        ]),
                                        _c("div", { staticClass: "col-md-7" }, [
                                          _vm._v(_vm._s(lvlArr[1])),
                                        ]),
                                      ])
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "base-collapse-item",
                          {
                            attrs: {
                              title: "Workflow Response Cache(es)",
                              name: "4",
                            },
                          },
                          [
                            _c("div", [
                              _c("div", [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _vm._v("Workflow Response Cache Size :"),
                                  ]),
                                  _c("div", { staticClass: "col-md-9" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.prodClassCriteria
                                            .workflowResponseMap.size
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c("div", [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _vm._v(
                                      " Workflow Response Cache Component : "
                                    ),
                                  ]),
                                  _c("div", { staticClass: "col-md-9" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.prodClassCriteria.workflowResponseMap.entries()
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c("div", [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _vm._v("Workflow Response Cache :"),
                                  ]),
                                  _c("div", { staticClass: "col-md-9" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.prodClassCriteria
                                            .workflowResponseCache
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "base-collapse-item",
                          {
                            attrs: { title: "Search Criteria Data", name: "4" },
                          },
                          [
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(
                                  _vm.criteriaMap,
                                  function (cache, keyMod, index) {
                                    return _c(
                                      "div",
                                      { key: keyMod, staticClass: "col-md-9" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(cache) +
                                            " ------- " +
                                            _vm._s(index) +
                                            " ------- " +
                                            _vm._s(keyMod) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }